import { API_SERVER } from "config";
import api from 'managers/apiManager';
import notificationManager from 'managers/notificationManager';
import fileDownload from 'js-file-download';

export const loadPublicDocuments = (state, receivedHandler, filter, busyHandler, alertRef) => {
    // console.log('loadPublicDocuments-filter: ', filter);
    busyHandler(true);
    api
        .post(`/public/documents`, filter)
        .then((response) => {
            if (response.data.isSuccess) {
                receivedHandler({ data: response.data.data, totalSize: response.data.totalSize });
            }
        })
        .finally(() => {
            busyHandler(false);
        })
        .catch((error) => {
            busyHandler(false);
            notificationManager.error(state, error, alertRef);
        });
};

export const loadPublicSingleDocument = (state, receivedHandler, publicId, busyHandler, alertRef) => {
    //console.log('loadSingleDocument-publicId: ', publicId);
    busyHandler(true);
    api
        .get(`/public/documents/single/${publicId}`)
        .then((response) => {
            if (response.data.isSuccess) {
                receivedHandler(response.data.data);
            }
        })
        .finally(() => {
            busyHandler(false);
        })
        .catch(function (error) {
            busyHandler(false);
            notificationManager.error(state, error, alertRef);
        });
};

export const attachmentDownload = async (state, fileId, fileName, busyHandler, alertRef) => {
    // console.log('attachmentDownload-fileId, fileName: ', fileId, fileName);
    if (busyHandler) busyHandler(true);
    await api
        .get(`/public/documents/attachment/${fileId}`, { responseType: 'blob'})
        .then((response) => {
            // console.log('attachmentDownload-response:', response);
            fileDownload(response?.data, fileName);
        })
        .finally(() => {
            if (busyHandler) busyHandler(false);
        })
        .catch(function (error) {
            if (busyHandler) busyHandler(false);
            if (alertRef) notificationManager.error(state, error, alertRef);
        });
};

export const logoMobileData = async (state, fileId, receivedHandler, errorHandler, busyHandler, alertRef) => {
    // console.log('attachmentDownload-fileId: ', fileId);
    if (busyHandler) busyHandler(true);
    await api
        .get(`/public/issuer/logo/${fileId}/data/${true}`)
        .then((response) => {
            // console.log('attachmentDownload-response:', response);
            if (response?.data?.isSuccess) {
                receivedHandler(response.data.data);
            }
            else if (response?.data) {
                receivedHandler(response.data);
            }
            else {
                if (errorHandler) errorHandler(response);
            }
        })
        .finally(() => {
            if (busyHandler) busyHandler(false);
        })
        .catch(function (error) {
            if (busyHandler) busyHandler(false);
            if (errorHandler) errorHandler(error);
            if (alertRef) notificationManager.error(state, error, alertRef);
        });
};

export const attachmentInfo = async (state, fileId, receivedHandler, errorHandler, busyHandler, alertRef) => {
    // console.log('attachmentDownload-fileId: ', fileId);
    if (busyHandler) busyHandler(true);
    await api
        .get(`/public/documents/attachment/${fileId}/info`)
        .then((response) => {
            // console.log('attachmentDownload-response:', response);
            if (response?.data?.isSuccess) {
                receivedHandler(response.data.data);
            }
            else {
                if (errorHandler) errorHandler(response);
            }
        })
        .finally(() => {
            if (busyHandler) busyHandler(false);
        })
        .catch(function (error) {
            if (busyHandler) busyHandler(false);
            if (errorHandler) errorHandler(error);
            if (alertRef) notificationManager.error(state, error, alertRef);
        });
};

export const attachmentData = async (state, fileId, receivedHandler, errorHandler, busyHandler, alertRef) => {
    // console.log('attachmentDownload-fileId: ', fileId);
    if (busyHandler) busyHandler(true);
    await api
        .get(`/public/documents/attachment/${fileId}/data`)
        .then((response) => {
            // console.log('attachmentDownload-response:', response);
            if (response?.data?.isSuccess) {
                receivedHandler(response.data.data);
            }
            else {
                if (errorHandler) errorHandler(response);
            }
        })
        .finally(() => {
            if (busyHandler) busyHandler(false);
        })
        .catch(function (error) {
            if (busyHandler) busyHandler(false);
            if (errorHandler) errorHandler(error);
            if (alertRef) notificationManager.error(state, error, alertRef);
        });
};

export const loadOldDocuments = async (state, filter, receivedHandler, busyHandler, alertRef) => {
    // console.log('loadOldDocuments-channelId, languageId: ', filter?.channelId, filter?.languageId, filter);
    if (busyHandler) busyHandler(true);
    await api
        .get(`/public/documents/old/${filter?.channelId}/${filter?.languageId}/${filter?.issuerId?filter?.issuerId:""}`)
        .then((response) => {
            // console.log('loadOldDocuments-response?.data?.data: ', response?.data?.data);
            if (response?.data?.isSuccess) {
                receivedHandler(response.data.data);
            }
        })
        .finally(() => {
            if (busyHandler) busyHandler(false);
        })
        .catch(function (error) {
            if (busyHandler) busyHandler(false);
            notificationManager.error(state, error, alertRef);
        });
};

export const oldDocumentDownload = async (state, oldDocument, busyHandler, alertRef) => {
    // console.log('oldDocumentDownload-oldDocumentId: ', oldDocumentId);
    busyHandler(true);
    await api
        .get(`/public/documents/old/single/${oldDocument?.oldDocumentId}`, { responseType: 'blob'})
        .then((response) => {
            // console.log('oldDocumentDownload-response: ', response);
            fileDownload(response?.data, oldDocument?.fileName);
        })
        .finally(() => {
            busyHandler(false);
        })
        .catch(function (error) {
            busyHandler(false);
            notificationManager.error(state, error, alertRef);
        });
};

export const loadIssuers = async (state, channelId, resultHandler, busyHandler, alertRef) => {
    // console.log('loadIssuers-channelId: ', channelId);
    busyHandler(true);
    await api
        .get(`/public/issuers/${channelId}`)
        .then((response) => {
            // console.log('loadIssuers-response:', response);
            resultHandler(response.data.data);
        })
        .finally(() => {
            busyHandler(false);
        })
        .catch(function (error) {
            busyHandler(false);
            notificationManager.error(state, error, alertRef);
        });
};

// export const loadLayoutsDelete = async (state, languageId, resultHandler, busyHandler, alertRef) => {
//     // console.log('loadLayouts-languageId: ', languageId);
//     busyHandler(true);
//     await api
//         .get(`/public/layouts/${languageId}`)
//         .then((response) => {
//             // console.log('loadLayouts-response:', response);
//             resultHandler(response.data.data);
//         })
//         .finally(() => {
//             busyHandler(false);
//         })
//         .catch(function (error) {
//             busyHandler(false);
//             notificationManager.error(state, error, alertRef);
//         });
// };

export const loadLayouts = async (state, channelId, languageId, resultHandler, busyHandler, alertRef) => {
    // console.log('loadLayouts-channelId,languageId: ', channelId, languageId);
    busyHandler(true);
    if (!channelId)
        return;
    await api
        .get(`/public/layouts/${channelId}/${languageId}`)
        .then((response) => {
            // console.log('loadLayouts-response:', response);
            resultHandler(response.data.data);
        })
        .finally(() => {
            busyHandler(false);
        })
        .catch(function (error) {
            busyHandler(false);
            notificationManager.error(state, error, alertRef);
        });
};

export const proxyAttachmentDownload = async (state, fileId, fileName, busyHandler, alertRef) => {
    // console.log('attachmentDownload-fileId, fileName: ', fileId, fileName);
    if (busyHandler) busyHandler(true);
    await api
        .get(`/public/mobile/attachment/${fileId}`, { responseType: 'blob'})
        .then(async (response) => {
            console.log('attachmentDownload-response:', response, response.headers);
            const contentDisposition = response.headers['content-disposition'];
            console.log('attachmentDownload-contentDisposition:', contentDisposition);

            if (contentDisposition && contentDisposition.includes('attachment')) {
                const matches = contentDisposition.match(/filename="(.+)"/);
                console.log('attachmentDownload-matches:', matches);
                if (matches.length > 1) {
                    fileName = matches[1];
                }
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = fileName; // Set the desired file name
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url); // Clean up the URL object
        })
        .finally(() => {
            if (busyHandler) busyHandler(false);
        })
        .catch(function (error) {
            console.log(error);
            if (busyHandler) busyHandler(false);
            if (alertRef) notificationManager.error(state, error, alertRef);
        });
};

export const fetchAttachmentDownload = async (state, fileId, fileName, busyHandler, alertRef) => {
    console.log('fetchAttachmentDownload-fileId, fileName: ', fileId, fileName);
    if (busyHandler) busyHandler(true);
    try {
        const response = await fetch(`${API_SERVER}/public/mobile/attachment/${fileId}`);
        console.log('attachmentDownload-response, headers:', response, response.headers);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const contentDisposition = response.headers.get('Content-Disposition');
        console.log('attachmentDownload-contentDisposition:', contentDisposition);
        if (contentDisposition && contentDisposition.includes('attachment')) {
            const matches = contentDisposition.match(/filename="(.+)"/);
            console.log('attachmentDownload-matches:', matches);
            if (matches.length > 1) {
                fileName = matches[1];
            }
        }

        // Create a blob from the response
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        
        // Create an anchor element to download the file
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName; // Set the desired file name
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url); // Clean up the URL object
    } catch (error) {
        console.log(error);
        if (alertRef) notificationManager.error(state, error, alertRef);
    }

    if (busyHandler) busyHandler(true);
};
